import { Action } from '@ngrx/store';
import {
    JournalEntry,
    JournalFilterInput
} from 'app/api/journal.api.service';
import { KeyStringFilterInput } from 'app/api/common.api.types';

export interface JournalQuery {
    companyId: string;
    key?: KeyStringFilterInput;
    filter?: JournalFilterInput;
}

export enum JournalActionTypes {
    JournalRequested = '[Journal View] Journal requested',
    JournalLoaded = '[Journal API] Journal loaded',
    JournalCancelled = '[Journal API] Journal cancelled',
    JournalEntryUpdateRequested = '[Journal View] Journal entry update requested',
    JournalEntryUpdated = '[Journal API] Journal entry updated',
    JournalEntryUpdateCancelled = '[Journal API] Journal entry update cancelled',
}

// LOAD ENTRIES
export class JournalRequested implements Action {
    readonly type = JournalActionTypes.JournalRequested;
    constructor(public payload: JournalQuery) {}
}
export class JournalLoaded implements Action {
    readonly type = JournalActionTypes.JournalLoaded;
    constructor(public payload: { journal: JournalEntry[] }) {}
}
export class JournalCancelled implements Action {
    readonly type = JournalActionTypes.JournalCancelled;
    constructor(public payload: { errorMessage: string }) {}
}

// UPDATE ENTRY
export class JournalEntryUpdateRequested implements Action {
    readonly type = JournalActionTypes.JournalEntryUpdateRequested;
    constructor(public payload: { entry: JournalEntry }) {}
}
export class JournalEntryUpdated implements Action {
    readonly type = JournalActionTypes.JournalEntryUpdated;
    constructor(public payload: { entry: JournalEntry }) {}
}
export class JournalEntryUpdateCancelled implements Action {
    readonly type = JournalActionTypes.JournalEntryUpdateCancelled;
    constructor(public payload: { errorMessage: string }) {}
}

export type JournalActions =
  JournalRequested
    | JournalLoaded
    | JournalCancelled
    | JournalEntryUpdateRequested
    | JournalEntryUpdated
    | JournalEntryUpdateCancelled;
